import BpaERas from '../pages/BpaERas/Index'
import BpaC from '../pages/BpaERas/BpaC/Index'
import BpaI from '../pages/BpaERas/BpaI/Index'
import Ras from '../pages/BpaERas/Ras/Index'

export default [
  {
    path: '/bpa-e-raas',
    component: BpaERas,
  },
  {
    path: '/bpa-e-raas/bpa-c',
    component: () => import('@/pages/BpaERas/BpaC/Template.vue'),
    children: [
      {
        path: '/bpa-e-raas/bpa-c',
        component: BpaC,
      },
    ],
  },
  {
    path: '/bpa-e-raas/bpa-i',
    component: () => import('@/pages/BpaERas/BpaI/Template.vue'),
    children: [
      {
        path: '/bpa-e-raas/bpa-i',
        component: BpaI,
      },
    ],
  },
  {
    path: '/bpa-e-raas/ras',
    component: () => import('@/pages/BpaERas/Ras/Template.vue'),
    children: [
      {
        path: '/bpa-e-raas/ras',
        component: Ras,
      },
    ],
  },
  {
    path: '/bpa-e-raas/exportar-bpa',
    component: () => import('@/pages/BpaERas/ExportarBpa/Index.vue'),
  },
  {
    path: '/bpa-e-raas/exportar-raas',
    component: () => import('@/pages/BpaERas/ExportarRaas/Index.vue'),
  },
  {
    path: '/bpa-e-raas/importar-raas',
    component: () => import('@/pages/BpaERas/ImportarRaas/Index.vue'),
  },
]
